// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"2bb981d5a1c2f992","4661":"be282bd3e33c20e3","4964":"f752b73dd8a2b21e","8109":"8c3ead4837992121","9750":"9881d9855e3946a2"}[chunkId] + ".css";
};